// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/bootstrap/dist/css/bootstrap.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/Mona-Sans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/FKGrotesk.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Mona Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2 supports variations'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2-variations');
  font-weight: 200 900;
  font-stretch: 75% 125%;
}

@font-face {
  font-family: 'FK Grotesk';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2 supports variations'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2-variations');
  font-weight: 200 900;
  font-stretch: 75% 125%;
}


html {
  --body-top-padding: 24px;
  -webkit-font-smoothing: antialiased;
  color: var(--sand12);
}


.btn {
  text-decoration: none;
}

#near-wallet-selector-modal .open{
  z-index: 1001;
}

#w3m-modal { z-index: 1002 }

#launcher {
  color-scheme: light;
  width: 48px;
  height: 50px;
  padding: 0px;
  margin: 10px 20px;
  position: fixed;
  bottom: 10px;
  overflow: visible;
  opacity: 1;
  border: 0px;
  z-index: 999998;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-property: opacity, top, bottom;
  right: 10px;
}

@media (max-width: 650px) {
  #launcher {
    right: 2px;
    bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;EACxB;sEACsE;EACtE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB;sEACsE;EACtE,oBAAoB;EACpB,sBAAsB;AACxB;;;AAGA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;AACtB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa,cAAc;;AAE3B;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,gEAAgE;EAChE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":["@import 'bootstrap';\n\n@font-face {\n  font-family: 'Mona Sans';\n  src: url('../../public/fonts/Mona-Sans.woff2') format('woff2 supports variations'),\n    url('../../public/fonts/Mona-Sans.woff2') format('woff2-variations');\n  font-weight: 200 900;\n  font-stretch: 75% 125%;\n}\n\n@font-face {\n  font-family: 'FK Grotesk';\n  src: url('../../public/fonts/FKGrotesk.woff2') format('woff2 supports variations'),\n    url('../../public/fonts/FKGrotesk.woff2') format('woff2-variations');\n  font-weight: 200 900;\n  font-stretch: 75% 125%;\n}\n\n\nhtml {\n  --body-top-padding: 24px;\n  -webkit-font-smoothing: antialiased;\n  color: var(--sand12);\n}\n\n\n.btn {\n  text-decoration: none;\n}\n\n#near-wallet-selector-modal .open{\n  z-index: 1001;\n}\n\n#w3m-modal { z-index: 1002 }\n\n#launcher {\n  color-scheme: light;\n  width: 48px;\n  height: 50px;\n  padding: 0px;\n  margin: 10px 20px;\n  position: fixed;\n  bottom: 10px;\n  overflow: visible;\n  opacity: 1;\n  border: 0px;\n  z-index: 999998;\n  transition-duration: 250ms;\n  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition-property: opacity, top, bottom;\n  right: 10px;\n}\n\n@media (max-width: 650px) {\n  #launcher {\n    right: 2px;\n    bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
